/**
 * Client-only config wrapper for Vite import.meta.env.
 * Do NOT import this from server code; use src/config/* on the server.
 */
type Env = Record<string, string | boolean | undefined>;

function raw(): Env {
  try { return import.meta.env || {}; } catch { return {}; }
}

function requireString(val: unknown, name: string): string {
  const v = typeof val === 'string' ? val : '';
  if (!v) throw new Error(`Missing required env: ${name}`);
  return v;
}

function asBool(val: string | boolean | undefined): boolean {
  if (typeof val === 'boolean') return val;
  if (val === undefined) return false;
  const s = val.toLowerCase();
  return s === '1' || s === 'true';
}

export const config = {
  clerkPublishableKey(): string {
    return requireString(raw().VITE_CLERK_PUBLISHABLE_KEY, 'VITE_CLERK_PUBLISHABLE_KEY');
  },
  allowedRedirectOrigins(): string[] {
    const r = String(raw().VITE_ALLOWED_REDIRECT_ORIGINS || '');
    return r.split(/[\\s,]+/).map((s) => s.trim()).filter(Boolean);
  },
  authDebug(): boolean {
    return asBool(raw().VITE_AUTH_DEBUG);
  },
  closeBeaconDebug(): boolean {
    return asBool(raw().VITE_CLOSE_BEACON_DEBUG);
  },
  virtualizeMail(): boolean {
    return String(raw().VITE_VIRTUALIZE_MAIL || '') === '1';
  },
  mode(): string {
    return String(raw().MODE || '');
  },
};


